import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMail, FiAward } = FiIcons;

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleNavClick = (href) => {
    if (location.pathname !== '/') {
      navigate('/' + href);
    } else {
      document.querySelector(href).scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          <div className="space-y-4">
            <Link to="/" className="inline-block">
              <span className="text-xl md:text-2xl font-bold bg-gradient-to-r from-blue-400 via-purple-400 to-blue-400 bg-clip-text text-transparent hover:from-purple-400 hover:via-blue-400 hover:to-purple-400 transition-all duration-300 tracking-tight">
                Premium SMM Panel
              </span>
            </Link>
            <p className="text-gray-400">
              Your trusted partner for social media growth. High-quality services with instant delivery and 24/7 support.
            </p>
            <div className="inline-flex items-center px-2.5 py-1 bg-gray-700 rounded-full text-xs">
              <SafeIcon icon={FiAward} className="w-3 h-3 mr-1 text-yellow-400" />
              <span className="text-gray-300">Rate us on</span>
              <a 
                href="https://www.topsmmpanels.com/panel/premiumsmmpanel" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="ml-1 text-blue-300 hover:text-blue-200 transition-colors"
              >
                TopSMMPanels
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => handleNavClick('#services')}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavClick('#features')}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Features
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavClick('#pricing')}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Pricing
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavClick('#faq')}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  FAQ
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/legal" className="text-gray-400 hover:text-white transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/legal" className="text-gray-400 hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiMail} className="w-5 h-5 text-gray-400" />
                <a
                  href="mailto:info@premiumsmmpanel.io"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  info@premiumsmmpanel.io
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 text-center">
          <p className="text-gray-400">© 2024 Premium SMM Panel. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;